import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzMessageType } from "ng-zorro-antd/message";
import { localize } from "@gtmhub/localization";

type UiValidationHintType = Extract<NzMessageType, "success" | "info" | "warning" | "error">;

@Component({
  selector: "ui-validation-hint",
  templateUrl: "./validation-hint.component.html",
  styleUrls: ["./validation-hint.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiValidationHintComponent {
  @Input() public hintContent: string;
  @Input() public hintType: UiValidationHintType = "info";
  @Input() @InputBoolean() public uiHideIcon = false;
  @Input() @InputBoolean() public isAccented = false;

  @HostBinding("class")
  public get hostClasses(): string[] {
    return [`ui-hint-${this.hintType}`, `${this.isAccented ? "accented" : ""}`];
  }

  public generateToastAriaLabel(type: UiValidationHintType): string {
    const hintAriaLabelMap: {
      [HintType in UiValidationHintType]: string;
    } = {
      info: localize("informative_cap"),
      success: localize("success_cap"),
      warning: localize("warning_cap"),
      error: localize("error_cap"),
    };

    return hintAriaLabelMap[type];
  }
}
